var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableList',{staticClass:"table-container",attrs:{"listData":_vm.listData,"defaultExpandAll":false,"tableColumns":_vm.tableColumns,"no-operation":""},scopedSlots:_vm._u([{key:"btn-group",fn:function(){return [_c('div')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }